import * as types from '@/store/mutations'
import api from '@/services/backorders.js'
//import moment from 'moment'


const actions = {
    /*
    * Fetches all scorelogentries
    * */
  loadAllBackorders({ commit }) {
    return new Promise((resolve, reject) => {
      api.getAllBackorders().then((res)=>{
        commit(types.SET_ALL_BACKORDERS,res)
        resolve(res)
      }).catch((ex)=>{
        reject(ex)
      })
    })
  },
  requestDeliveryOfBackorder(commit, params) {
    return new Promise((resolve, reject) => {
      console.log('requesting bo delivery with payload', params);
      api.requestDeliveryOfBackorder(params).then((res)=>{
        resolve(res)
      }).catch((ex)=>{
        reject(ex)
      })
    })
  }
}

const mutations = {
    [types.SET_ALL_BACKORDERS](state, backorders) {
        state.backorders = backorders
    },
}

const state = {
  backorders: [],
}

export default {
  state,
  actions,
  mutations
}
